import angular from 'angular';
import '../../shared.module';
import template from './export-menu.component.html';
import './export-menu.component.scss';

export const EXPORT_FORMATS = [
  { value: 'csv', label: 'CSV' },
  { value: 'xlsx', label: 'Excel (XLSX)' }
];

export const PDF_EXPORT_FORMAT = { value: 'pdf', label: 'PDF com gráficos' };

export const EXPORT_FORMATS_WITH_PDF = [PDF_EXPORT_FORMAT, ...EXPORT_FORMATS];

class ExportMenuController {
  constructor() {
    this.open = false;
  }

  $onInit() {
    this.formats = this.formats || EXPORT_FORMATS;
  }

  toggle() {
    if (this.disabled || this.busy) return;
    this.open = !this.open;
  }

  close() {
    this.open = false;
  }

  choose(format) {
    this.open = false;
    if (this.onExport) this.onExport({ format });
  }
}

angular.module('app.shared').component('cpExportMenu', {
  bindings: {
    busy: '<',
    disabled: '<',
    permission: '@',
    formats: '<',
    onExport: '&'
  },
  controller: ExportMenuController,
  controllerAs: 'vm',
  template
});
